<template>

    <q-input
        class="mw-form-v2-input"
        :filled="settings.theme.input.filled"
        :outlined="settings.theme.input.outlined"
        :standout="settings.theme.input.standout"
        :borderless="settings.theme.input.borderless"
        :rounded="settings.theme.input.rounded"
        :square="settings.theme.input.square"
        :dense="settings.theme.input.dense"
        v-model="fieldValue"
        :label="field.layout_injected_label ? field.layout_injected_label : field.label"
        mask="#####"
        fill-mask
        unmasked-value
        debounce="1000"
        :loading="isLoading"
        :hide-bottom-space="hide_bottom_space"
        :rules="field.required  ? [

            val => !!val || requiredText,
            val => val.length > 4 || 'Please use 5 digits',
            val => isValidUsZipcode() || 'Please type valid us zipcode'

            ] : []">
      <template v-slot:append>
        <q-icon name="s_place" />
      </template>
       <template v-slot:label>
         {{field.layout_injected_label ? field.layout_injected_label : field.label}}
      <OptionalLabel :field="field"></OptionalLabel>
      </template>
    </q-input>

</template>

<script>
//import libphonenumber from "google-libphonenumber";
import {mapFields} from "vuex-map-fields";
import OptionalLabel from "@/components/OptionalLabel";
import {debounce} from "quasar";
import {mapActions} from "vuex";
export default {
  props: {
    modelValue: {},
    field:{},
    hide_bottom_space: null
  },
  data() {
    return {
      searchForStateD: null,
      isLoading: false
    };
  },
  components: {OptionalLabel},
  emits: ['update:modelValue'],
  methods: {
    ...mapActions({
      updateFieldValueByFieldType: 'values/list/updateFieldValueByFieldType'
    }),
    isValidUsZipcode() {
      return true;
      // try {
      //   if(this.fieldValue.length < 10) {
      //     return false;
      //   }
      //   const phone = libphonenumber.PhoneNumberUtil.getInstance().parse(this.fieldValue, 'US');
      //   return libphonenumber.PhoneNumberUtil.getInstance().isValidNumberForRegion(phone, 'US');
      // } catch (e) {
      //   return false
      // }

    },
    searchForState(value) {
      if(value.length === 5) {
        this.searchForStateD(value);
      }
    }
  },
  computed: {
    ...mapFields('settings/list', {
      settings: 'settings',
      form: 'form'
    }),
    requiredText: function () {
      return this.field.required_text ? this.field.required_text : 'Please type zipcode';
    },
    fieldValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
        this.searchForState(value);
      },
    }
  },
  mounted() {
    this.searchForStateD = debounce((value) => {
      this.isLoading = true;
      fetch('https://maps.googleapis.com/maps/api/geocode/json?sensor=true&key=AIzaSyCjz-8tkz0VaoW6j5k29KE8t0Jctfe19ns&components=country:US|postal_code:'+value)
          .then((response) => {
            return response.json();
          })
          .then((data) => {
            if(data['results'][0] !== undefined && data['results'][0]['address_components']) {
              for (let i in data['results'][0]['address_components']) {
                if(
                    data['results'][0]['address_components'][i]['types'].includes("administrative_area_level_1")
                ) {
                  const stateValue = data['results'][0]['address_components'][i]['short_name'];
                  if(stateValue) {
                    this.updateFieldValueByFieldType({form: this.form, type: 'location.state', fieldValue: stateValue});
                  }
                }
              }
            }
            this.isLoading = false;
            //zipcode_state_autocomplete_in_progress = false;
          });
    }, 300);
  }
}
</script>
